'use client'

import { ACCOUNTS_CONTACT, COMPANIES, CONTACTS, CONTACTS_NO_SLASH, PASSWORD } from '../constants'
import { type IUserContactData, type IUserContactForm } from '../types'
import { serverFetchApi, useUpFetch } from '../utils'

export const useShipperLoginApi = () => {
  const upFetch = useUpFetch()

  const fetchUserContacts = async (companyId: number) =>
    serverFetchApi<IUserContactData>(
      `/${COMPANIES}${companyId}/${CONTACTS_NO_SLASH}${ACCOUNTS_CONTACT}`,
    )

  const patchUserContacts = async (
    companyId: number | undefined,
    contactId: number | undefined,
    data: IUserContactForm,
  ) => {
    return upFetch<{ data: IUserContactData }>(
      `/${COMPANIES}${companyId}/${CONTACTS}${contactId}`,
      {
        body: data,
        method: 'PATCH',
      },
    )
  }

  const postUserContacts = async (companyId: number | undefined, data: IUserContactForm) => {
    return upFetch<{ data: IUserContactData }>(`/${COMPANIES}${companyId}/${CONTACTS_NO_SLASH}`, {
      body: data,
      method: 'POST',
    })
  }

  const changeUserPassword = async (
    userId: number | undefined,
    data: { password: string; password_confirmation: string },
  ) => {
    return upFetch<{ data: boolean }>(`/users/${userId}/${PASSWORD}`, {
      body: data,
      method: 'PATCH',
    })
  }

  return {
    changeUserPassword,
    fetchUserContacts,
    patchUserContacts,
    postUserContacts,
  }
}
